import { useState, useCallback, useEffect } from "react";
import { fetchCrewList, fetchCrewByVessel } from "../../EmployeesListFld/EmployeesListApi";

export const useCrewList = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const result = await fetchCrewList();
      setData(result);
      setFilteredData(result);
    } catch (error) {
      console.error("Error fetching crew list:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleFilter = useCallback((value) => {
    if (!value) { setData(filteredData); return; }
    const lower = value.toLowerCase();
    const res = filteredData.filter(f =>
      f?.vesselName?.toLowerCase().includes(lower) ||
      f?.destinationHeadName?.toLowerCase().includes(lower)
    );
    setData(res);
  }, [filteredData]);

  return { loading, data, handleFilter, fetchData };
};